"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerValidateQuestionOnStart = exports.surveyValidateQuestion = exports.surveyOnVisibleQuestionChanged = exports.surveyAfterRenderQuestionInput = exports.surveyAfterRenderQuestion = exports.removeErrorOnDisabledQuestion = exports.handleAutoScroll = exports.default = exports.convertCustomFormJsonData = exports.canSetValueToSurveyOverride = exports.addBlurEvent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var SurveyReact = _interopRequireWildcard(require("survey-react-ui"));
var Survey = _interopRequireWildcard(require("survey-core"));
var widgets = _interopRequireWildcard(require("surveyjs-widgets"));
var _survey = _interopRequireDefault(require("./survey.scss"));
var _customSurvey = _interopRequireDefault(require("./customSurvey"));
var _customQuestionDropdown = _interopRequireDefault(require("./dropdown/customQuestionDropdown"));
var _customQuestionDate = _interopRequireDefault(require("./date/customQuestionDate"));
var _CustomQuestionRadio = _interopRequireDefault(require("./singleradio/CustomQuestionRadio"));
var _toolboxCustom = _interopRequireDefault(require("../toolboxCustom"));
var _multiQuestionCheckboxModel = _interopRequireDefault(require("./questionModel/multiQuestionCheckboxModel"));
var _singleQuestionRadiogroupModel = _interopRequireDefault(require("./questionModel/singleQuestionRadiogroupModel"));
var _questionDateModel = _interopRequireDefault(require("./questionModel/questionDateModel"));
var _customQuestionDropdownModel = _interopRequireDefault(require("./questionModel/customQuestionDropdownModel"));
var _constants = require("../toolboxCustom/constants");
var _constants2 = require("./constants");
var _customQuestionDateTime = _interopRequireDefault(require("./date/customQuestionDateTime"));
var _questionHelper = require("./questionHelper");
var _CustomReadOnlyQuestion = _interopRequireDefault(require("./readonly/CustomReadOnlyQuestion"));
var _customQuestionText = _interopRequireDefault(require("./text/customQuestionText"));
var _customQuestionBoolean = _interopRequireDefault(require("./boolean/customQuestionBoolean"));
var _customQuestionMultipleText = _interopRequireDefault(require("./multipletextitem/customQuestionMultipleText"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
widgets.inputmask(Survey);
var CLASS_NAME = _survey.default['preview-custom-form-survey'];
var UPDATE_MODE = {
  ON_BLUR: 'onBlur',
  ON_TYPING: 'onTyping'
};
var VIEW_MODE = {
  VIEW: 'readOnly'
};
Survey.StylesManager.applyTheme('modern');
Survey.Serializer.removeProperty('selectbase', 'choicesFromQuestion');
Survey.Serializer.addProperty('question', {
  name: 'internalType'
});
Survey.settings.lazyRowsRendering = true;

/**
 * Init Toolbox when component is creating
 */

var initToolbox = function initToolbox(t) {
  _toolboxCustom.default.MultiCheckboxToolbox(Survey, _multiQuestionCheckboxModel.default, t);
  _toolboxCustom.default.HeaderToolbox(Survey, t);
  _toolboxCustom.default.SingleRadioToolbox(Survey, _singleQuestionRadiogroupModel.default, t, false);
  _toolboxCustom.default.DateToolbox(Survey, _questionDateModel.default, t);
  _toolboxCustom.default.DropdownToolbox(Survey, _customQuestionDropdownModel.default, t);
  var emailToolbox = (0, _constants.getToolboxItems)(t).find(function (i) {
    return i.name === _constants.MODEL_QUESTIONS.EMAIL;
  });
  var phoneToolbox = (0, _constants.getToolboxItems)(t).find(function (i) {
    return i.name === _constants.MODEL_QUESTIONS.PHONE;
  });
  var numberToolbox = (0, _constants.getToolboxItems)(t).find(function (i) {
    return i.name === _constants.MODEL_QUESTIONS.NUMBER;
  });
  if (Survey.Serializer.findClass(_constants.MODEL_QUESTIONS.EMAIL) === undefined) {
    _toolboxCustom.default.EmailToolbox(Survey, t, emailToolbox);
  }
  if (Survey.Serializer.findClass(_constants.MODEL_QUESTIONS.PHONE) === undefined) {
    _toolboxCustom.default.PhoneToolbox(Survey, t, phoneToolbox);
  }
  if (Survey.Serializer.findClass(_constants.MODEL_QUESTIONS.NUMBER) === undefined) {
    _toolboxCustom.default.NumberToolbox(Survey, t, numberToolbox);
  }
};

/**
 * Update default value for config json data
 * @param {Object} defaultValueObject
 * @param {Object} jsonData
 * @returns
 */
var convertCustomFormJsonData = function convertCustomFormJsonData(defaultValueObject, jsonData, isReadOnly) {
  var cloneJsonData = _lodash.default.cloneDeep(jsonData);
  if (_lodash.default.isEmpty(defaultValueObject) && !isReadOnly) {
    return jsonData;
  }
  (0, _questionHelper.updateQuestion)(cloneJsonData, function (question) {
    return (0, _questionHelper.setDefaultValueHanlder)(question, defaultValueObject);
  });
  return cloneJsonData;
};

/**
 * Validation support function
 * Trigger remove error and data on question disabled by enableIf
 * @param {Survey} survey
 */
exports.convertCustomFormJsonData = convertCustomFormJsonData;
var removeErrorOnDisabledQuestion = function removeErrorOnDisabledQuestion(survey) {
  var pageQuestions = survey.getAllQuestions(true);
  pageQuestions.forEach(function (question) {
    var parent = question.parent,
      enableIf = question.enableIf,
      isReadOnly = question.isReadOnly;
    var internalQuestion = question;
    var isInPanelEnableIf = parent && parent.isPanel && !_lodash.default.isEmpty(parent.enableIf);
    var hasErrors = internalQuestion.errors && internalQuestion.errors.length > 0;
    if (isReadOnly && (!_lodash.default.isEmpty(enableIf) || isInPanelEnableIf) && hasErrors) {
      internalQuestion.clearErrors();
    }
  });
};

/**
 * Extend question validation
 * @param {Survey} survey
 * @param {Object} options
 */
exports.removeErrorOnDisabledQuestion = removeErrorOnDisabledQuestion;
var surveyValidateQuestion = function surveyValidateQuestion(survey, options) {
  if (options.question.getType() === 'dateCustom') {
    _questionHelper.ValidationSupport.validateDateTimeQuestion(options);
  } else if (options.question.getType() === 'multicheckbox' || options.question.getType() === 'dropdownCustom' || options.question.getType() === 'radiogroup') {
    var _options$question = options.question,
      renderedValue = _options$question.renderedValue,
      hasOther = _options$question.hasOther;
    if (!hasOther && renderedValue) {
      var checkValue = Array.isArray(renderedValue) ? renderedValue.includes('other') : renderedValue === 'other';
      if (checkValue) {
        var internalOptions = options;
        internalOptions.error = _constants2.INVALID_UPLOAD_ANSWER;
      }
    }
  } else if (options.question.getType() === 'boolean') {
    _questionHelper.ValidationSupport.validateBooleanQuestion(options);
  } else if (options.question.internalType === _constants.TOOLBOX_TYPE.NUMBERS) {
    _questionHelper.ValidationSupport.validateNumberQuestion(options);
  }
  // Trigger remove error and data on question disabled by enableIf
  removeErrorOnDisabledQuestion(survey);
};

/**
 * Override question method to validate set value
 */
exports.surveyValidateQuestion = surveyValidateQuestion;
var canSetValueToSurveyOverride = function canSetValueToSurveyOverride(question) {
  var internalQuestion = question;
  internalQuestion.canSetValueToSurvey = function () {
    if (question.value !== null && question.value !== undefined && question.value !== '') {
      if (!question.isMinMaxType) return true;
      if (question.isValueLessMin) return false;
      if (question.isValueGreaterMax) return false;
    }
    return true;
  };
};

/**
 * Regis onblur event for input to check question errors
 * fire callback function to fire change
 * @param {Object} element
 * @param {Object} question
 */
exports.canSetValueToSurveyOverride = canSetValueToSurveyOverride;
var addBlurEvent = function addBlurEvent(callFunc, formId, element, question) {
  element.addEventListener('blur', function (e) {
    if (e && e.target.value !== '') {
      question.hasErrors(true);
      if (callFunc) {
        callFunc(formId, question.survey);
      }
    }
  });

  // Override the input set value to catch the input value
  // which was changed by javascript
  // First store the initial descriptor of the "value" property:
  var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  var inputSetter = descriptor.set;
  // Then modify the "setter" of the value to notify when the value is changed:
  descriptor.set = function defineSetter(val) {
    // changing to native setter to prevent the loop while setting the value
    Object.defineProperty(this, 'value', {
      set: inputSetter
    });
    var isChange = this.value !== val;
    this.value = val;
    // Trigger custom logic if value is changed successfully
    if (isChange && this.value === val) {
      question.hasErrors(true);
      if (callFunc) {
        // Survey data need to be updated with question value before calling onValueChanging
        question.survey.setValue(question.name, question.value);
        callFunc(formId, question.survey);
      }
    }
    // changing back to custom setter
    Object.defineProperty(this, 'value', descriptor);
  };
  // Last add the new "value" descriptor to the $input element
  Object.defineProperty(element, 'value', descriptor);
};

/**
 * Add callback event to custom question element after render
 * @param {Function} callFunc
 * @param {String} formId
 */
exports.addBlurEvent = addBlurEvent;
var surveyAfterRenderQuestion = function surveyAfterRenderQuestion(isReadOnly) {
  return function (__, options) {
    var question = options.question;
    if (question.getType() === 'dateCustom') {
      canSetValueToSurveyOverride(question);
    } else if (_constants2.READ_ONLY_QUESTIONS.includes(question.getType())) {
      question.readOnly = isReadOnly || question.readOnly;
    }
  };
};

/**
 * Add callback event to custom question input element after render
 * @param {Function} callFunc
 * @param {String} formId
 */
exports.surveyAfterRenderQuestion = surveyAfterRenderQuestion;
var surveyAfterRenderQuestionInput = function surveyAfterRenderQuestionInput(callFunc, formId, t) {
  return function (__, options) {
    var htmlElement = options.htmlElement,
      question = options.question;
    htmlElement.placeholder = t(_constants2.PLACE_HOLDER[options.question.internalType]) || t(_constants2.PLACE_HOLDER.text);
    question.placeHolder = t(_constants2.PLACE_HOLDER[options.question.internalType]) || t(_constants2.PLACE_HOLDER.text);
    if (question.getType() === 'boolean') {
      question.hasRequiredError = function () {
        return question.isRequired && question.isEmpty() && !question.defaultValue;
      };
    } else if (question.internalType === _constants.TOOLBOX_TYPE.NUMBERS) {
      canSetValueToSurveyOverride(question);
      var internalQuestion = question;
      htmlElement.type = 'number';
      htmlElement.title = '';
      internalQuestion.correctValueType = _questionHelper.correctNumberValue;
      addBlurEvent(callFunc, formId, htmlElement, question);
    } else if (question.internalType === 'rating') {
      question.displayMode = 'buttons';
    }
  };
};

/**
 * Add validate event to custom question element after render
 * @param {Boolean} needValidateWhenLoadData
 * @param {Function} triggerRender
 */
exports.surveyAfterRenderQuestionInput = surveyAfterRenderQuestionInput;
var triggerValidateQuestionOnStart = function triggerValidateQuestionOnStart(needValidateWhenLoadData, triggerRender) {
  return function (__, options) {
    if (!needValidateWhenLoadData || !options || !options.question) {
      return;
    }
    if (options.question.hasErrors(true)) {
      triggerRender(true);
    }
  };
};
exports.triggerValidateQuestionOnStart = triggerValidateQuestionOnStart;
var surveyOnVisibleQuestionChanged = function surveyOnVisibleQuestionChanged(__, options) {
  var internalOptions = options;
  if (internalOptions.visible === false) internalOptions.question.value = null;
};

// disable auto scroll up
exports.surveyOnVisibleQuestionChanged = surveyOnVisibleQuestionChanged;
var handleAutoScroll = function handleAutoScroll(__, options) {
  var eleOptions = options;
  if (eleOptions.cancel === false) eleOptions.cancel = true;
};
exports.handleAutoScroll = handleAutoScroll;
var CustomSurveyPreview = function CustomSurveyPreview(props) {
  var isSubmit = props.isSubmit,
    onSubmitData = props.onSubmitData,
    className = props.className,
    customFormId = props.customFormId,
    onValueChanged = props.onValueChanged,
    onValueChanging = props.onValueChanging,
    textUpdateMode = props.textUpdateMode,
    viewMode = props.viewMode,
    isShowFormName = props.isShowFormName,
    needValidateWhenLoadData = props.needValidateWhenLoadData,
    isDateTimeRender = props.isDateTimeRender,
    t = props.t,
    locale = props.locale;
  var _React$useState = _react.default.useState(null),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    survey = _React$useState2[0],
    setSurvey = _React$useState2[1];
  var _React$useState3 = _react.default.useState(),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    triggerRender = _React$useState4[1];
  var isReadOnly = viewMode === VIEW_MODE.VIEW;
  (0, _react.useEffect)(function () {
    initToolbox(t);
    var configJson = convertCustomFormJsonData(props.customFormData.defaultValue, props.customFormData.configJson, isReadOnly);
    var onValueChangingCallback = function onValueChangingCallback(formId, surveyModel, options) {
      return onValueChanging(formId, (0, _questionHelper.convertOutputData)(surveyModel), options);
    };
    (0, _questionHelper.updateInputNumberValidation)(configJson);
    var newSurvey = new SurveyReact.Model(configJson);
    if (!isReadOnly) {
      newSurvey.onValidateQuestion.add(surveyValidateQuestion);
    }
    newSurvey.onAfterRenderQuestionInput.add(surveyAfterRenderQuestionInput(onValueChangingCallback, customFormId, t));
    newSurvey.onAfterRenderQuestion.add(surveyAfterRenderQuestion(isReadOnly));
    newSurvey.onAfterRenderQuestion.add(triggerValidateQuestionOnStart(needValidateWhenLoadData, triggerRender));
    newSurvey.onVisibleChanged.add(surveyOnVisibleQuestionChanged);
    newSurvey.onScrollingElementToTop.add(handleAutoScroll);
    newSurvey.questionErrorLocation = 'bottom';
    newSurvey.focusFirstQuestionAutomatic = false;
    newSurvey.focusOnFirstError = false;
    // Clears question value when question or its containter (page or section) becomes invisible.
    // If the question is invisible initially, its value is removed on survey completion.
    newSurvey.clearInvisibleValues = 'onHiddenContainer';
    _toolboxCustom.default.defineDateCSS(newSurvey);
    _toolboxCustom.default.defineHeaderCSS(newSurvey);
    _toolboxCustom.default.defineMultiCheckboxCSS(newSurvey);
    _toolboxCustom.default.defineRadioGroupCSS(newSurvey);
    _toolboxCustom.default.defineDropdownCSS(newSurvey);
    _toolboxCustom.default.definePhoneCSS(newSurvey);
    _toolboxCustom.default.defineEmailCSS(newSurvey);
    _toolboxCustom.default.defineNumberCSS(newSurvey);
    if (onValueChanged) {
      // Should clear onValueChanged events of previous survey instance
      if (survey) {
        survey.onValueChanged.clear();
      }
      newSurvey.onValueChanged.add(function (sender, options) {
        var internalOptions = options;
        var numberRegex = new RegExp(_constants.NUMBER_INPUT_REGEX);
        if (internalOptions.question.internalType === _constants.TOOLBOX_TYPE.NUMBERS && !numberRegex.test(internalOptions.question.defaultValue)) {
          // Just clear defaultValue of numberCustom when it is invalid
          internalOptions.question.defaultValue = '';
        }
        var internalSender = sender;
        if (internalSender.textUpdateMode !== UPDATE_MODE.ON_BLUR) {
          internalSender.textUpdateMode = UPDATE_MODE.ON_BLUR;
        }
        if (options.question) {
          options.question.hasErrors(true);
        }
        if (options.question.isVisible === false) {
          internalOptions.question.defaultValue = null;
        }
        onValueChanged(customFormId, (0, _questionHelper.convertOutputData)(internalSender), options);
      });
    }
    if (onValueChanging) {
      // Should clear onValueChanging events of previous survey instance
      if (survey) {
        survey.onValueChanging.clear();
      }
    }
    newSurvey.textUpdateMode = textUpdateMode;
    newSurvey.checkErrorsMode = 'onValueChanged';
    setSurvey(newSurvey);
  }, [props.customFormData.configJson, viewMode]);
  (0, _react.useEffect)(function () {
    if (viewMode !== VIEW_MODE.VIEW) {
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('text', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_customQuestionText.default, _objectSpread(_objectSpread({}, inprops), {}, {
          t: t
        }));
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('multicheckbox', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_customQuestionDropdown.default, _objectSpread(_objectSpread({}, inprops), {}, {
          multi: true,
          t: t
        }));
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('singleradio', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_CustomQuestionRadio.default, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('radiogroup', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionRadiogroup, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('dateCustom', function (inprops) {
        if (isDateTimeRender) {
          return /*#__PURE__*/_react.default.createElement(_customQuestionDateTime.default, _objectSpread(_objectSpread({}, inprops), {}, {
            t: t,
            locale: locale
          }));
        }
        return /*#__PURE__*/_react.default.createElement(_customQuestionDate.default, _objectSpread(_objectSpread({}, inprops), {}, {
          t: t,
          locale: locale
        }));
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('dropdownCustom', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_customQuestionDropdown.default, _objectSpread(_objectSpread({}, inprops), {}, {
          t: t
        }));
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('boolean', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_customQuestionBoolean.default, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('expression', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionExpression, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('signaturepad', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionSignaturePad, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('multipletext', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(_customQuestionMultipleText.default, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('matrix', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionMatrix, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('matrixdropdown', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionMatrixDropdown, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('comment', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionComment, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('rating', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionRating, inprops);
      });
      SurveyReact.ReactQuestionFactory.Instance.registerQuestion('ranking', function (inprops) {
        return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyQuestionRanking, inprops);
      });
    } else {
      // Register custom question to render as text field in read-only mode
      _constants2.CUSTOM_READ_ONLY_QUESTION_TYPES.forEach(function (questionType) {
        SurveyReact.ReactQuestionFactory.Instance.registerQuestion(questionType, function (inprops) {
          return /*#__PURE__*/_react.default.createElement(_CustomReadOnlyQuestion.default, inprops);
        });
      });
    }
  }, [viewMode]);
  (0, _react.useEffect)(function () {
    if (isSubmit && survey) {
      onSubmitData({
        key: customFormId,
        value: (0, _questionHelper.convertOutputData)(survey)
      });
    }
  }, [isSubmit, survey]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CLASS_NAME, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svc-creator"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svc-creator-tab__content svc-test-tab__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svc-plugin-tab__content ".concat(isReadOnly ? 'view-mode' : '')
  }, isShowFormName && props.customFormData.name && /*#__PURE__*/_react.default.createElement("div", {
    className: "svc-form-name"
  }, props.customFormData.name), survey && /*#__PURE__*/_react.default.createElement(_customSurvey.default, {
    model: survey,
    needClearErrorsWhenAllQuestionIsEmpty: props.needClearErrorsWhenAllQuestionIsEmpty
  })))));
};
CustomSurveyPreview.propTypes = {
  customFormData: _propTypes.default.shape({
    configJson: _propTypes.default.shape({}).isRequired,
    defaultValue: _propTypes.default.shape({}).isRequired,
    name: _propTypes.default.string.isRequired
  }).isRequired,
  isSubmit: _propTypes.default.bool,
  className: _propTypes.default.string,
  onSubmitData: _propTypes.default.func.isRequired,
  onValueChanged: _propTypes.default.func,
  onValueChanging: _propTypes.default.func,
  customFormId: _propTypes.default.string.isRequired,
  textUpdateMode: _propTypes.default.string,
  viewMode: _propTypes.default.string,
  isShowFormName: _propTypes.default.bool,
  needValidateWhenLoadData: _propTypes.default.bool,
  needClearErrorsWhenAllQuestionIsEmpty: _propTypes.default.bool,
  isDateTimeRender: _propTypes.default.bool,
  t: _propTypes.default.func,
  locale: _propTypes.default.string
};
CustomSurveyPreview.defaultProps = {
  isSubmit: false,
  className: '',
  onValueChanged: _lodash.default.noop,
  onValueChanging: _lodash.default.noop,
  textUpdateMode: UPDATE_MODE.ON_BLUR,
  viewMode: '',
  isShowFormName: false,
  needValidateWhenLoadData: false,
  needClearErrorsWhenAllQuestionIsEmpty: false,
  isDateTimeRender: false,
  t: function t(x) {
    return x;
  },
  locale: 'en-us'
};
var _default = CustomSurveyPreview;
exports.default = _default;